import { render, staticRenderFns } from "./CommentEmoteCreator.vue?vue&type=template&id=77fe3c45&scoped=true"
import script from "./CommentEmoteCreator.vue?vue&type=script&lang=ts"
export * from "./CommentEmoteCreator.vue?vue&type=script&lang=ts"
import style0 from "./CommentEmoteCreator.vue?vue&type=style&index=0&id=77fe3c45&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fe3c45",
  null
  
)

export default component.exports